import VideoGroups from 'Pages/video/groups-origin'

export default VideoGroups
